import dark from './assets/dark.webp';
import googleDefault from './assets/default.webp';
import grayscale from './assets/grayscale.webp';
import light from './assets/light.webp';

/**
 * Preview thumbnails for each map color style, keyed by the ColorStyle value
 * used in the MapStyleControl radio options ('grayscale' | 'default' | 'light' | 'dark').
 *
 * Shared across the MapStyleControl copies in the tracking, geofences and
 * monitoring modules so the image assets live in a single place.
 */
export const MAP_STYLE_PREVIEWS: Record<string, string> = {
  grayscale,
  default: googleDefault,
  light,
  dark,
};
